__turbopack_context__.v({
  "filter-footer": "filter-footer-module-scss-module__mn4I5q__filter-footer",
  "filter-footer__apply-button": "filter-footer-module-scss-module__mn4I5q__filter-footer__apply-button",
});
